import React from 'react';
import { FadeIn, Section } from './ui';
export function ProductSection() {
  const modules = [{
    num: '01',
    title: 'Capta Atención',
    desc: '6 ideas de apertura listas para usar según el tipo de aula que tengas. Capturás la atención en los primeros 10 minutos o no la capturás nunca.',
    tag: 'TOMO 1'
  }, {
    num: '02',
    title: 'Ingeniería de la Guía',
    desc: 'Plantillas de guías que se explican solas. Tus alumnos trabajan solos mientras vos observás. Terminan las 30 preguntas repetidas por clase.',
    tag: 'TOMO 2'
  }, {
    num: '03',
    title: 'El Pizarrón que se Entiende',
    desc: 'El sistema de 4 zonas y código de color que convierte tu pizarrón en una herramienta de comprensión. Lo que escribís, los alumnos lo entienden.',
    tag: 'TOMO 3'
  }, {
    num: '04',
    title: 'Evaluación Segura',
    desc: 'Exámenes con rúbricas técnicas irrefutables. Ningún padre puede cuestionar la nota. Ninguna IA puede resolverlos sin razonamiento propio.',
    tag: 'TOMO 4'
  }, {
    num: '05',
    title: 'Gestión de Consultas',
    desc: "El banco de 50 respuestas listas para las preguntas más difíciles del aula. Incluyendo '¿para qué sirve esto?' con ejemplos de cripto, fútbol e IA.",
    tag: 'TOMO 5'
  }, {
    num: '06',
    title: 'El Cierre de Autoridad',
    desc: 'El protocolo de 10 minutos que duplica la retención de contenido sin agregar tiempo de clase. Lo último que recordás es lo que más recordás.',
    tag: 'TOMO 6'
  }];
  return <Section variant="light" className="!max-w-none" data-id="element-210">
      <div className="max-w-[800px] mx-auto" data-id="element-211">
        <FadeIn data-id="element-212">
          <h2 className="text-[28px] md:text-4xl font-black text-gray-900 mb-6 text-center" data-id="element-213">
            ¿Qué es exactamente Matemática 360?
          </h2>
          <p className="text-gray-600 text-base md:text-lg mb-12 leading-relaxed text-center" data-id="element-214">
            Es un sistema de 6 módulos en formato PDF que cubre los 6 momentos
            críticos de cada clase: cómo empezarla, cómo diseñar las
            actividades, cómo usar el pizarrón, cómo evaluar, cómo gestionar las
            preguntas y cómo cerrar para que los alumnos recuerden lo aprendido.
            Cada módulo tiene: la teoría en 2 páginas, las plantillas para
            copiar y los checklists para verificar antes de entrar al aula.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-215">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.07} data-id="element-216">
              <div className="bg-white border border-brand-green/30 p-5 md:p-6 rounded-2xl h-full flex flex-col hover:border-brand-green hover:shadow-[0_8px_30px_rgb(5,150,105,0.12)] transition-all duration-300 relative overflow-hidden group" data-id="element-217">
                <div className="absolute top-0 right-0 bg-brand-green text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-218">
                  {mod.tag}
                </div>
                <div className="text-3xl md:text-4xl font-black text-gray-200 mb-1 group-hover:text-brand-green/20 transition-colors" data-id="element-219">
                  {mod.num}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-220">
                  {mod.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed flex-grow" data-id="element-221">
                  {mod.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}